
  import { defineComponent, onMounted, ref, computed, nextTick } from 'vue';
  import { ErrorMessage, Field, Form } from 'vee-validate';
  import { setCurrentPageBreadcrumbs } from '@/core/helpers/breadcrumb';
  import { useI18n } from 'vue-i18n/index';
  import { useStore } from 'vuex';
  import { useRouter } from 'vue-router';
  import { Actions } from '@/store/enums/StoreEnums';
  import { useAbility } from '@casl/vue';
  import * as Yup from 'yup';
  import jsPDF from 'jspdf';
  import autoTable from 'jspdf-autotable';
  import { getUser } from '@/core/services/AuthService';
  import LookupNameIds from '@/store/enums/settingsEnums';
  import { injectSearch } from '@/core/plugins/search-service';
  import SearchField from '@/components/common/SearchField.vue';
  import { loadImage } from '../../../utils/loadImage';
  import moment from 'moment';

  export default defineComponent({
    name: 'groomer-lessons-count-report',
    components: {
      ErrorMessage,
      Field,
      Form,
      SearchField,
    },
    async setup() {
      const { t, te } = useI18n();
      const store = useStore();
      const router = useRouter();
      const submitButton = ref<HTMLButtonElement | null>(null);
      const { can } = useAbility();
      const selectedItem = ref<number>(0);
      const loadingPage = ref(true);
      const searchService = injectSearch();
      const reportData = ref();
      const selectedCustomer = ref<number>(0);
      const selectedTrainer = ref<number>(0);
      const selectedHorse = ref<number>(0);
      const selectedArena = ref<number>(0);
      const selectedAttendance = ref<number>(0);
      const selecteDuration = ref<number>(0);
      const selecteType = ref<number>(0);
      const selectedDay = ref<number>(0);
      const selectedGroomer = ref<number>(0);
      const selectedMonth = ref<string>('');
      const selectedYear = ref<string>('');
      const startDate = ref(
        moment().startOf('month').format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
      );
      const endDate = ref(
        moment()
          .startOf('month')
          .add(1, 'month')
          .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
      );
      const years: number[] = [];
      const excelData = ref();
      const jsonExcel = ref();
      const months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ];
      store.dispatch(Actions.ADD_BODY_CLASSNAME, 'page-loading-extra');
      const translate = (text) => {
        if (te(text)) {
          return t(text);
        } else {
          return text;
        }
      };

      const goBack = () => {
        router.back();
      };

      onMounted(async () => {
        setCurrentPageBreadcrumbs(translate('GroomerLessonCountReport'), [
          translate('reports'),
        ]);
        const currentYear = new Date().getFullYear();
        for (let year = 2020; year <= currentYear; year++) {
          years.push(year);
        }
        store.dispatch(Actions.GET_ALL_CUSTOMERS);
        store.dispatch(Actions.GET_ALL_TRAINERS, {});
        store.dispatch(Actions.GET_ALL_ARENAS);
        store.dispatch(Actions.GET_ALL_HORSES_OPERATIONS);
        store.dispatch(Actions.GET_ALL_GROOMERS_OPERATIONS);
        const getSaveData = searchService.getSearchValue(
          'GroomerLessonCountReport'
        );
        const dataSaved =
          Object.keys(getSaveData).length > 0
            ? JSON.parse(
                searchService.getSearchValue('GroomerLessonCountReport')
              )
            : {};
        if (Object.keys(getSaveData).length > 0) {
          if (dataSaved.startDate) startDate.value = dataSaved.startDate;
          if (dataSaved.endDate) endDate.value = dataSaved.endDate;
          if (dataSaved.horseId) selectedHorse.value = dataSaved.horseId;
          if (dataSaved.customerId)
            selectedCustomer.value = dataSaved.customerId;

          if (dataSaved.year) selectedYear.value = dataSaved.year;
          if (dataSaved.month) selectedMonth.value = dataSaved.month;
        }
        loadingPage.value = false;
        store.dispatch(Actions.REMOVE_BODY_CLASSNAME, 'page-loading-extra');
      });
      const clearSearch = () => {
        searchService.removeSearchValue('GroomerLessonCountReport');
        selectedCustomer.value = 0;
        selectedHorse.value = 0;
        selectedMonth.value = '';
        selectedYear.value = '';
        startDate.value = moment()
          .startOf('month')
          .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
        endDate.value = moment()
          .startOf('month')
          .add(1, 'month')
          .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
      };

      const print = async (values) => {
        store.dispatch(Actions.ADD_BODY_CLASSNAME, 'page-loading-extra');

        searchService.setSearchValue('GroomerLessonCountReport', values);

        const user = getUser();
        const userName = user ? user['name'] : '';

        await store.dispatch(Actions.GET_GROOMER_LESSONS_COUNT, values);

        reportData.value = store.getters.getGroomerLessonsCount;

        const doc = new jsPDF({
          format: 'a4',
          orientation: 'landscape',
        });
        const fontSize = doc.getFontSize();

        let textX =
          (doc.internal.pageSize.getWidth() -
            doc.getTextWidth('Kuwait Riding Center')) /
          2;

        let pageCount = 0;
        let header: any[] = [];
        const resTabelBody: any[] = [];
        header.push('groomer');
        reportData.value.data.forEach(function (element, index) {
          resTabelBody.push([]);

          resTabelBody[index].push(element.groomer);

          // let idx = 0;
          for (const id in element.lessonCounts) {
            const lesson = element.lessonCounts[id];

            if (index == 0) {
              header.push(new Date(id).getDate());
            }
            resTabelBody[index].push(lesson);
          }
          if (index == 0) {
            header.push('Cnt');

            header.push('Hrs');

            header.push('30');
            header.push('45');
          }
          resTabelBody[index].push(element.totalCount['total']);
          resTabelBody[index].push(element.totalCount['totalMinutes'] / 60);
          resTabelBody[index].push(element.totalCount['30']);
          resTabelBody[index].push(element.totalCount['45']);
        });

        autoTable(doc, {
          head: [header],
          body: resTabelBody,
          horizontalPageBreak: true,
          styles: {
            fontSize: 8,
            overflow: 'hidden',
          },
          startY: 45,
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          //@ts-ignore
          margin: { horizontal: 'auto', top: 45 },
          headStyles: {
            fillColor: [0, 72, 115],
            fontStyle: 'bold',
            halign: 'left',
          },
          bodyStyles: {
            fontStyle: 'bold',
            halign: 'left',
          },
          columnStyles: {
            0: { cellWidth: 20, overflow: 'hidden' },
          },
          didDrawPage: function () {
            doc.setFontSize(10);
            pageCount++;
            const pageCountWidth = doc.getTextWidth(String(pageCount));

            doc.text(
              'Page ' + pageCount,
              textX - pageCountWidth,
              doc.internal.pageSize.height - 9
            );
            doc.setFontSize(fontSize);
          },
        });
        const logoImage = await loadImage('/media/logos/empty-krc.png');

        Array.from({ length: pageCount }, (x, i) => {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          //@ts-ignore
          doc.addImage(logoImage, 'png', 5, 3, 35, 35);
          doc.setFontSize(14);
          doc.setFont('helvetica', 'bold');
          doc.text('Kuwait Riding Center', textX, 12);
          doc.setFontSize(12);
          doc.text('Groom Utilization Report', textX, 20);
          doc.setFontSize(10);
          doc.text(
            'Start Date: ' + moment(values.startDate).format('LLL'),
            80,
            30
          );
          doc.text(
            'End Date: ' + moment(values.endDate).format('LLL'),
            160,
            30
          );

          doc.text('Print DateTime: ' + moment(new Date()).format('LLL'), 5, 8);

          doc.setFont('helvetica', 'normal');
          doc.setPage(i + 1);
          doc.text(userName, 5, doc.internal.pageSize.height - 10);
          doc.setFontSize(10);
          doc.text(
            '     of ' + doc.getNumberOfPages(),
            textX + 15,
            doc.internal.pageSize.height - 9
          );
          doc.setFontSize(fontSize);
        });

        // doc.save('table.pdf');
        // doc.autoPrint();
        const data = doc.output('blob');
        const blobUrl = URL.createObjectURL(data);
        store.dispatch(Actions.REMOVE_BODY_CLASSNAME, 'page-loading-extra');
        window.open(blobUrl, '_blank');
      };

      const printExcel = async () => {
        try {
          store.dispatch(Actions.ADD_BODY_CLASSNAME, 'page-loading-extra');

          const values = {
            startDate: String(startDate.value),
            endDate: String(endDate.value),
            horseId: selectedHorse.value,
            year: selectedYear.value,
            month: selectedMonth.value,
          };

          await store.dispatch(Actions.GET_GROOMER_LESSONS_COUNT, values);
          reportData.value = store.getters.getGroomerLessonsCount;

          const resTabelBody: Record<string, string | number>[] = [];
          console.log('reportData.value', reportData.value);
          // Check if data exists
          if (reportData.value && reportData.value.data) {
            reportData.value.data.forEach((element, index) => {
              // Add main groomer row
              const groomerRow: Record<string, string | number> = {
                Groomer: element.groomer,
              };

              // Add daily lesson counts as separate columns first
              for (const date in element.lessonCounts) {
                const fullDate = moment(date).format('DD/MM/YYYY');
                groomerRow[fullDate] = element.lessonCounts[date];
              }

              // Add summary columns at the end
              groomerRow['Total Count'] = element.totalCount['total'];
              groomerRow['Total Hours'] = (
                element.totalCount['totalMinutes'] / 60
              ).toFixed(2);
              groomerRow['30 min Count'] = element.totalCount['30'];
              groomerRow['45 min Count'] = element.totalCount['45'];

              resTabelBody.push(groomerRow);
            });
          }

          excelData.value = resTabelBody;

          await nextTick();

          if (jsonExcel.value && resTabelBody.length > 0) {
            jsonExcel.value.generate();
            jsonExcel.value.$el.style.display = 'none';
          } else if (resTabelBody.length === 0) {
            alert('No data available for export');
          }
        } catch (error) {
          console.error('Error exporting Excel:', error);
          alert('Error exporting data. Please try again.');
        } finally {
          store.dispatch(Actions.REMOVE_BODY_CLASSNAME, 'page-loading-extra');
        }
      };

      const excelHeader = computed(() => {
        const baseHeaders = {
          Groomer: 'Groomer',
        };

        // Add day columns dynamically based on the month first
        if (
          reportData.value &&
          reportData.value.data &&
          reportData.value.data.length > 0
        ) {
          const firstGroomer = reportData.value.data[0];
          for (const date in firstGroomer.lessonCounts) {
            const fullDate = moment(date).format('DD/MM/YYYY');
            baseHeaders[fullDate] = fullDate;
          }
        }

        // Add summary columns at the end
        baseHeaders['Total Count'] = 'Total Count';
        baseHeaders['Total Hours'] = 'Total Hours';
        baseHeaders['30 min Count'] = '30 min Count';
        baseHeaders['45 min Count'] = '45 min Count';

        return baseHeaders;
      });

      const validationSchema = Yup.object().shape({});

      await store.dispatch(Actions.GET_ALL_SETTINGS_LOOKUPS, [
        LookupNameIds.DAYS,
        LookupNameIds.CLASS_TYPE,
        LookupNameIds.DURATION,
        LookupNameIds.STATUS,
        LookupNameIds.ATTENDEND,
      ]);

      const lookupsList = computed(() => store.getters.allLookupsList);

      const statusList = lookupsList.value.filter((lookup) => {
        return lookup.lookupNameId === LookupNameIds.ATTENDEND;
      });

      const classType = lookupsList.value.filter((lookup) => {
        return lookup.lookupNameId === LookupNameIds.CLASS_TYPE;
      });

      const dayList = lookupsList.value.filter((lookup) => {
        return lookup.lookupNameId === LookupNameIds.DAYS;
      });

      const durationList = lookupsList.value.filter((lookup) => {
        return lookup.lookupNameId === LookupNameIds.DURATION;
      });

      return {
        selectedItem,
        submitButton,
        translate,
        validationSchema,
        goBack,
        can,
        print,
        reportData,
        customers: computed(() => store.getters.allCustomersList),
        trainers: computed(() => store.getters.allTrainersList),
        arenas: computed(() => store.getters.allArenasList),
        horses: computed(() => store.getters.allHorsesList),
        groomers: computed(() => store.getters.allGroomerList),
        statusList,
        classType,
        dayList,
        durationList,
        selectedCustomer,
        selectedTrainer,
        selectedArena,
        selectedHorse,
        selecteDuration,
        selectedAttendance,
        selecteType,
        selectedDay,
        selectedGroomer,
        years,
        months,
        selectedMonth,
        selectedYear,
        startDate,
        endDate,
        loadingPage,
        clearSearch,
        printExcel,
        excelData,
        excelHeader,
        jsonExcel,
      };
    },
  });
